import { type MRT_RowData, type MRT_TableOptions } from 'material-react-table'

import { pagination } from './constants/ui'

const getDefaultMRTOptions = <TData extends MRT_RowData>(): Partial<
  MRT_TableOptions<TData>
> => ({
  enableGlobalFilter: false,
  enableRowPinning: false,
  initialState: { showColumnFilters: false },
  manualFiltering: true,
  manualPagination: true,
  manualSorting: true,
  paginationDisplayMode: 'pages',
  enableColumnActions: false,
  enableStickyHeader: true,
  enableTopToolbar: true,
  enableSorting: false,
  muiPaginationProps: {
    rowsPerPageOptions: pagination.pageSizeOptions,
    showFirstButton: true,
    showLastButton: true,
  },
  getRowId: (row, index) => (row?.id && row.id.toString()) || index.toString(),
  muiTableBodyProps: () => ({
    sx: {
      '& td.MuiTableCell-root': {
        height: '3.25rem',
        paddingTop: '0',
        paddingBottom: '0',
        maxWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      '& td.MuiTableCell-root.Mui-TableBodyCell-DetailPanel': {
        height: 'auto',
      },
      '& tr': {
        backgroundColor: 'unset !important',
        transition:
          'background-color 130ms ease-in-out 0s, box-shadow 130ms ease-in-out 0s',
      },
      '& tr:hover': {
        cursor: 'pointer',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0.4rem 0px 1.1rem',
      },
      '& tr:hover td': {
        backgroundColor: 'rgb(255, 255, 255)',
      },
    },
  }),
  muiTableContainerProps: {
    sx: {
      maxHeight: 'calc(100vh - 21rem)',
    },
  },
})

export default getDefaultMRTOptions
